import script from "./BaseField.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseField.vue?vue&type=script&setup=true&lang=ts"

import "./BaseField.vue?vue&type=style&index=0&id=1a9ec618&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a9ec618"]])

export default __exports__